function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M14.706 1v2.178h-2.229v2.215H6.61L18 24.996 29.392 5.393h-8.09V3.215h2.21V1H32.2C33.746 1 35 2.246 35 3.782c0 .489-.13.968-.375 1.391l-14.2 24.435a2.81 2.81 0 0 1-4.85 0L1.375 5.173a2.772 2.772 0 0 1 1.026-3.8A2.814 2.814 0 0 1 3.8 1h10.905zm3.298 15.229a1.56 1.56 0 0 1 1.566 1.555c0 .422-.168.804-.442 1.084v.033h-.033c-.282.272-.667.44-1.09.44a1.56 1.56 0 0 1-1.567-1.557 1.56 1.56 0 0 1 1.566-1.555zm1.124-8.603v2.196h-2.21V7.626h2.21zm-2.21-2.197v2.197h-2.212V5.429h2.211z"
});

var SvgLogoVWhite = function SvgLogoVWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoVWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_v_white.c2a118b1.svg";
export { ForwardRef as ReactComponent };